import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import IncorrectLinkCodePage from './IncorrectLinkCodePage';
import {
  validatedLinkCodeAndRedirect,
  dataCaptureSelectors,
  resetLinkCodeError
} from '../../store/dataCapture';
import { CREATE_CASE_ERROR, USERNAME_PASSWORD, LINK_CODE_KEY } from '../../utils/constants';

class IncorrectLinkCodeSection extends Component {
  componentDidMount() {
    this.props.resetLinkCodeError();
  }
  render() {
    const {
      validatedLinkCodeAndRedirect,
      linkCodeError,
      customerData,
      getBusinessData
    } = this.props;
    return (
      <IncorrectLinkCodePage
        saveEnterLinkCodeForm={validatedLinkCodeAndRedirect}
        linkCodeError={linkCodeError}
        customerData={customerData}
        getBusinessData={getBusinessData}
      />
    );
  }
}

IncorrectLinkCodeSection.propTypes = {
  saveEnterLinkCodeForm: PropTypes.func.isRequired
};

const actionCreators = {
  validatedLinkCodeAndRedirect,
  resetLinkCodeError
};

const mapStateToProps = state => ({
  linkCodeError: dataCaptureSelectors.getBusinessData(state, CREATE_CASE_ERROR),
  customerData: dataCaptureSelectors.getBusinessData(state, USERNAME_PASSWORD),
  getBusinessData: { link_code: selectors.getSingleEntry(state, LINK_CODE_KEY) }
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(IncorrectLinkCodeSection);
